import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VeeValidate from 'vee-validate'
import { VeeValidateConfig, cyrAlpha } from '@/utils/validate'
import UiIcon from '@/components/UiIcon.vue' // SVG icon component
import UiButton from '@/components/UiButton' // Button component
import UiTooltip from './components/UiTooltip.vue' // Tooltip component
import UiFormField from '@/components/UiFormField.vue' // Form field component

Vue.component(UiIcon.name, UiIcon) // UI SVG icon component use
Vue.component(UiTooltip.name, UiTooltip) // UI tooltip component
Vue.component(UiButton.name, UiButton) // Button component
Vue.component(UiFormField.name, UiFormField) // UI form field component

// Custom validator
VeeValidate.Validator.extend('cyr_alpha', cyrAlpha)

Vue.use(VeeValidate, VeeValidateConfig)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
